import type { PropsWithChildren } from "react";
import { CollectionsLayoutContext } from "#collections-layout-context";
import { useCollectionsLayoutContextValue } from "#use-collections-layout-context-value";

export function CollectionsLayoutContextProvider({ children }: PropsWithChildren) {
  const value = useCollectionsLayoutContextValue();
  return (
    <CollectionsLayoutContext.Provider value={value}>{children}</CollectionsLayoutContext.Provider>
  );
}
